import React from 'react';
import { useIntl } from 'react-intl';
import { ClockIcon, UsersIcon } from '@heroicons/react/24/outline';

export default function ProgramCard({ program, coach, className = '' }) {
  const intl = useIntl();
  if (!program) return null;
  const onClick = () => {
    try {
      if (window.ahoy && typeof window.ahoy.track === 'function') {
        window.ahoy.track('marketplace_program_click', { slug: program.slug, program_id: program.id });
      }
    } catch (_) {}
  };
  return (
    <a
      href={`/sprints/programs/${program.slug}`}
      onClick={onClick}
      className={`group block rounded-2xl overflow-hidden border border-border bg-card transition-all hover:shadow-md hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-[var(--succession-focus-ring)] ${className}`}
    >
      {/* Hero Image - fills to top edges */}
      <div className="relative h-48 bg-muted">
        {program.hero_image_url && (
          <img src={program.hero_image_url} alt={program.title} className="w-full h-full object-cover" />
        )}
        {program.featured && (
          <span className="absolute top-3 right-3 inline-flex items-center px-2.5 py-1 rounded-md text-xs font-semibold bg-succession-primary text-white shadow-sm">
            {intl.formatMessage({ id: 'sprints.program_card.featured' })}
          </span>
        )}
      </div>
      <div className="p-6 space-y-4">
        {/* Title & Summary - black text, changes to primary on hover */}
        <div>
          <h3 className="font-semibold text-[17px] leading-6 mb-1 line-clamp-2 text-gray-900 group-hover:text-succession-primary transition-colors">{program.title}</h3>
          {program.summary && <p className="text-sm text-gray-600 line-clamp-2">{program.summary}</p>}
        </div>
        {coach && (
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              {coach.avatar_url && <img src={coach.avatar_url} alt={coach.name} className="w-8 h-8 rounded-full" />}
              <div className="min-w-0">
                <p className="text-sm font-medium truncate text-gray-900">{coach.name}</p>
                <p className="text-xs text-gray-600 truncate">{coach.headline}</p>
              </div>
            </div>
            {/* Duration and Group/1:1 info */}
            <div className="flex items-center gap-4 text-xs text-gray-600">
              {program.duration_days && (
                <div className="flex items-center gap-1">
                  <ClockIcon className="w-4 h-4" />
                  <span>{intl.formatMessage({ id: 'sprints.program_card.days' }, { days: program.duration_days })}</span>
                </div>
              )}
              <div className="flex items-center gap-1">
                <UsersIcon className="w-4 h-4" />
                <span>{program.is_group ? intl.formatMessage({ id: 'sprints.program_card.group' }) : intl.formatMessage({ id: 'sprints.program_card.one_on_one' })}</span>
              </div>
            </div>
          </div>
        )}
        {/* Level & Price */}
        <div className="flex items-center justify-between text-sm">
          <span className="inline-flex items-center px-2.5 py-1 rounded-md bg-gray-100 text-gray-900 text-xs font-medium capitalize border border-gray-200">
            {program.level}
          </span>
          <span className="font-semibold text-[18px] text-gray-900">
            {program.price_cents ? `$${(program.price_cents / 100).toLocaleString()}` : intl.formatMessage({ id: 'sprints.program_card.free' })}
          </span>
        </div>
      </div>
    </a>
  );
}


